import React, { useState, useEffect } from 'react';
import { Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, CircularProgress, OutlinedInput } from '@mui/material';
import { Search as SearchIcon, CleaningServices as CleaningServicesIcon, Add as AddIcon } from '@mui/icons-material';


function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}

export default function FiltrosBuscaProdutos({ onSearch, onClear, oncreate, grupos, sub_grupos }) {
    const [filtros, setFiltros] = useState({
        nome: '',
        cod_produto: '',
        status: '',
        cod_grupo: '',
        cod_subgrupo: '',
        cod_consulta: ''
    });


    const debouncedFiltros = useDebounce(filtros, 500);

    useEffect(() => {
        // Dispara a busca apenas se o usuário preencheu algo
        const isFiltroPreenchido = Object.values(debouncedFiltros).some(v => v !== '' && v !== 0);
        if (isFiltroPreenchido) {
            onSearch(debouncedFiltros);
        }
    }, [debouncedFiltros, onSearch]);

    const handleChange = (e) => {
        setFiltros(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleClearClick = () => {
        setFiltros({
            nome: '',
            cod_produto: 0,
            status: 'S',
            cod_grupo: '',
            cod_subgrupo: '',
            cod_consulta: ''
        });
        onClear();
    };

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item
                size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
            >
                <TextField
                    fullWidth
                    name="nome"
                    value={filtros.nome}
                    onChange={handleChange}
                    label='Nome do produto'
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                />
            </Grid>
            <Grid
                item
                size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
            >
                <TextField
                    type='number'
                    fullWidth
                    name="cod_produto"
                    value={filtros.cod_produto}
                    onChange={handleChange}
                    variant="outlined"
                    label='Código do produto'
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}

                />
            </Grid>
            <Grid
                item
                size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
            >
                <TextField
                    type='number'
                    fullWidth
                    name="cod_consulta"
                    value={filtros.cod_consulta}
                    onChange={handleChange}
                    label="Código de consulta"
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                />
            </Grid>
            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    select
                    fullWidth
                    label="Ativo"
                    name="status"
                    value={filtros.status === '' ? 'S' : filtros.status}
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                >
                    <MenuItem value="S">Sim</MenuItem>
                    <MenuItem value="N">Não</MenuItem>
                </TextField>
            </Grid>
            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    select
                    fullWidth
                    label="Grupo"
                    name="cod_grupo"
                    value={filtros.cod_grupo}
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                >
                    {grupos.map((grup) => {
                        return (

                            <MenuItem value={grup.cod_grupo}>{grup?.nome || "Não informado"}</MenuItem>
                        )
                    })}

                </TextField>
            </Grid>
            <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                <TextField
                    select
                    fullWidth
                    label="Sub grupo"
                    name="cod_subgrupo"
                    value={filtros.cod_subgrupo}
                    onChange={handleChange}
                    variant="outlined"
                    InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                    InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                >
                    {sub_grupos.map((sub) => {
                        return (

                            <MenuItem value={sub.cod_subgrupo}>{sub?.nome || "Não informado"}</MenuItem>
                        )
                    })}
                </TextField>
            </Grid>

            <Grid container spacing={1} size={{ sx: 12, sm: 12, md: 12, lg: 12, xl: 12, xs: 12 }} justifyContent="flex-end">
                <Grid item>
                    <Button variant="outlined" onClick={handleClearClick} title="Limpar filtros">
                        <CleaningServicesIcon />
                    </Button>
                </Grid>
                <Grid item >
                    <Button onClick={() => { oncreate() }} title="Adicionar" variant="outlined" ><AddIcon /></Button>
                </Grid>
            </Grid>
        </Grid>
    );
}